import '../styles/NavigationMobileMenuItem.css';
import { object } from 'prop-types';
import React, { useCallback, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import NavigationMobileMenuItemIcons from './NavigationMobileMenuItemIcons';


/** CONFIGURATION */
/**
 * @constant {number} DEFAULT_MAX_CHILD_ITEMS
 * The default maximum number of child items to display when the
 * `maxChildItemsToDisplay` property is not set or is zero.
 */
const DEFAULT_MAX_CHILD_ITEMS = 8;
/**
 * @constant {boolean} USE_DEFAULT_LIMIT
 * Determines whether to use the default limit for the number of child items to
 * display or display all children when the `maxChildItemsToDisplay` property
 * is not set or is zero.
 */
const USE_DEFAULT_LIMIT = true;

const NavigationMobileMenuItem = ({ navLink }) => {
    const [expanded, setExpanded] = useState(false);

    const menuItems = useMemo(() => {
        const { children } = navLink;
        const menuItemCount = children?.length ?? 0;
        if (menuItemCount === 0) {
            return [];
        }
        const { maxChildItemsToDisplay } = navLink;
        if (typeof maxChildItemsToDisplay === 'undefined'
            || maxChildItemsToDisplay === null
            || maxChildItemsToDisplay === 0) {
            return USE_DEFAULT_LIMIT === true
                ? children.slice(0, DEFAULT_MAX_CHILD_ITEMS)
                : children;
        }
        return children.slice(0, maxChildItemsToDisplay);
    });

    const toggleExpanded = useCallback(() => {
        setExpanded((prevExpanded) => !prevExpanded);
    }, []);

    return (<div
        className={'nav-mobile-menu-item'}>
        <div
            className={'nav-mobile-menu-item--header'}
        >
            <Link
                to={navLink.url}
                className={'m-0 p-0 custom-link'}>{navLink.title}</Link>
            {menuItems.length > 0
                ? <NavigationMobileMenuItemIcons
                    expanded={expanded}
                    toggleExpanded={toggleExpanded} />
                : null
            }
        </div>
        {menuItems.length > 0 && (<div
            className={`nav-mobile-menu-item--links${expanded === true ? ' is-expanded' : ''}`}>
            <div
                className={'nav-mobile-menu-item--view-all-link'}>
                <a
                    className={'custom-link'}
                    href={navLink.url}>
                    View All {navLink.title}
                </a>
            </div>
            <div>
                {menuItems.map((child) => (<div
                    className={'nav-mobile-menu-item--child'}
                    key={child.id}>
                    <Link
                        className={'custom-link'}
                        to={child.url}>
                        {child.title}
                    </Link>
                </div>))}
            </div>
        </div>)}
    </div>);
};

NavigationMobileMenuItem.defaultProps = {};
NavigationMobileMenuItem.propTypes = {
    navLink: object,
};

export default NavigationMobileMenuItem;